import type { MailboxInfo } from "owa-client-types";
import store from "../store/Store";

export function getEnabledFlights(mailboxInfo?: MailboxInfo): string[] {
    const featureFlags = store(mailboxInfo).featureFlags;
    return [...featureFlags.keys()];
}
